import gql from "graphql-tag";

export const UPDATE_ALLOW_TWO_FACTOR_AUTH_PROMPT = gql`
  mutation UpdateAllowTwoFactorAuthPrompt($userId: String!) {
    updateAllowTwoFactorAuthPrompt(userId: $userId)
  }
`;
